'use strict';

/*
 * conversionTracking.js -- Platinum Partner page conversion events, sent to GA4 and to Umbraco Engage.
 * Contract: specs/004-platinum-partner-conversion/contracts/analytics-events.md
 *
 *   CTA click         a[href$="#umbraco-project"]
 *                     GA4 `umbraco_project_cta_click` { placement, link_url, link_text }
 *                     Engage "Platinum partner" / "CTA click" / placement
 *                     placement is "hero" inside .pw-basic-hero, otherwise "secondary".
 *   Case study click  a[data-case-study]
 *                     GA4 `umbraco_case_study_click` { case_id, link_url, link_text }
 *                     Engage "Platinum partner" / "Case study click" / case_id
 *   Lead              Forms' submitted message inside [data-lead-form] (blockForm "Track submissions as leads")
 *                     GA4 `generate_lead` { form_id }
 *                     Engage "Platinum partner" / "Lead" / form_id
 *
 * The lead relies on Umbraco Forms' Post/Redirect/Get: the submitted message renders once, only after the
 * server accepted the entry, so validation failures, quiz failures and a refresh after the redirect send nothing.
 * If a Forms upgrade renames .umbraco-forms-submitmessage(-html), the lead stops silently - re-run quickstart Q-E4.
 *
 * gtag only exists on www.proworks.com (see MainMaster.cshtml), so the GA4 call is skipped everywhere else.
 * umbEngage loads on every environment; Engage's GA4 bridge also records a name-only "GA 4 - Bridging" copy on
 * live - report on the "Platinum partner" category and ignore the bridged copy (as for homeHeroCta.js).
 *
 * Never reads what a visitor typed, never blocks a click or a submission.
 */

var ENGAGE_CATEGORY = 'Platinum partner';
var leadSent = false;

function send(gaEvent, gaParams, engageAction, engageLabel) {
    if (typeof window.gtag === 'function') {
        window.gtag('event', gaEvent, gaParams);
    }
    if (typeof window.umbEngage === 'function') {
        window.umbEngage('send', 'event', ENGAGE_CATEGORY, engageAction, engageLabel);
    }
}

function linkParams(link) {
    return {
        link_url: link.getAttribute('href') || '',
        link_text: (link.textContent || '').trim()
    };
}

function onClick(e) {
    try {
        var link = e.target && e.target.closest ? e.target.closest('a') : null;
        if (!link) {
            return;
        }

        var href = link.getAttribute('href') || '';
        if (/#umbraco-project$/.test(href)) {
            var placement = link.closest('.pw-basic-hero') ? 'hero' : 'secondary';
            var ctaParams = linkParams(link);
            ctaParams.placement = placement;
            send('umbraco_project_cta_click', ctaParams, 'CTA click', placement);
        } else if (link.hasAttribute('data-case-study')) {
            var caseId = link.getAttribute('data-case-study');
            var caseParams = linkParams(link);
            caseParams.case_id = caseId;
            send('umbraco_case_study_click', caseParams, 'Case study click', caseId);
        }
    } catch (err) {
        // Tracking must never break navigation.
    }
}

function reportLead() {
    try {
        if (leadSent) {
            return;
        }
        // Forms renders a plain-text message as .umbraco-forms-submitmessage and a rich-text one
        // ("message on submit is HTML") as .umbraco-forms-submitmessage-html, so either means a lead.
        var message = document.querySelector('[data-lead-form] .umbraco-forms-submitmessage, [data-lead-form] .umbraco-forms-submitmessage-html');
        if (!message) {
            return;
        }
        var formId = message.closest('[data-lead-form]').getAttribute('data-lead-form');
        leadSent = true;
        send('generate_lead', { form_id: formId }, 'Lead', formId);
    } catch (err) {
        // Tracking must never break the page.
    }
}

function init() {
    document.addEventListener('click', onClick);
    reportLead();
}

module.exports = { init: init };
